<template>
  <div class="col-12 h-100">
    <div class="row h-100">
      <div class="mail-actions col-12">
        <div class="row">
          <div class="col-2">
            <button class="btn btn-default">
              <i class="fas fa-bars"></i>
            </button>

            <router-link to="/compose" class="compose-email-btn">
              <button class="btn btn-info btn-sm">
                <i class="far fa-edit text-white"></i> New Message
              </button>
            </router-link>
          </div>

          <div class="col-10 p-0">
            <button class="btn btn-info btn-sm btn-default trigger-send-email-btn mt-1" @click="triggerSendEmail">
              <i class="fa fa-paper-plane text-white"></i> Send
            </button>
          </div>
        </div>
      </div>

      <div class="col-2 mail-folders">

        <div class="folder">
          <router-link to="/0/inbox"><i class="fas fa-inbox"></i> Inbox</router-link>
        </div>

        <!--        <div class="folder">-->
        <!--          <i class="fas fa-ban"></i> Junk Email-->
        <!--        </div>-->

        <!--        <div class="folder">-->
        <!--          <i class="fas fa-pencil-alt"></i> Drafts-->
        <!--        </div>-->

        <div class="folder">
          <router-link to="/0/sent"><i class="far fa-paper-plane"></i> Sent Items</router-link>
        </div>

        <div class="folder">
          <router-link to="/0/trash"><i class="far fa-trash-alt"></i> Deleted</router-link>
        </div>

        <!--        <div class="folder">-->
        <!--          <i class="fas fa-archive"></i> Archive-->
        <!--        </div>-->
      </div>
      <div class="col-9 h-100">
        <compose-webmail reply-to=""
                         send-to=""
                         reply-body=""
                         forward-body=""></compose-webmail>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    triggerSendEmail(e) {
      e.preventDefault();
      $('.send-email-btn').trigger('click');
    }
  }
}
</script>